(function() {
    'use strict';
    angular.module('elogbooks.admin.timesheet-types', []);
})();
